import React from 'react';
import Icon from '../../../components/AppIcon';

const GenerationPanel = ({
  isGenerating,
  cadImages,
  moodImages,
  generationError,
  onGenerate,
  onCancelGeneration,
  creditCost
}) => {
  return (
    <>
      {/* Generate Button - always visible */}
      <button
        onClick={onGenerate}
        disabled={isGenerating || cadImages.length === 0 || moodImages.length === 0}
        className="w-full glassmorphic-button rounded-xl md:rounded-2xl py-3 text-white font-medium flex items-center justify-center gap-2 hover:scale-[1.02] transition-transform disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100">
        {isGenerating ? (
          <>
            <Icon name="Loader" size={18} className="animate-spin" />
            Generating...
          </>
        ) : (
          <>
            <Icon name="Sparkles" size={18} />
            Generate Image
          </>
        )}
      </button>

      {/* Cancel Button - only shows during generation */}
      {isGenerating && (
        <button
          onClick={onCancelGeneration}
          className="w-full glassmorphic-button rounded-xl md:rounded-2xl py-2 text-sm text-white/70 font-medium flex items-center justify-center gap-2 hover:text-white transition-colors"
        >
          <Icon name="X" size={16} />
          Cancel
        </button>
      )}

      <p className="text-white/50 text-xs text-center">Your request will cost {creditCost} credit{creditCost !== 1 ? 's' : ''}</p>

      {generationError && (
        <div className="bg-red-500/20 border border-red-500/30 rounded-xl p-4">
          <p className="text-red-300 text-sm">{generationError}</p>
        </div>
      )}
    </>
  );
};

export default GenerationPanel;